import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { H7, Stack } from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';

export const ProcessingCard = () => {
  const t = useTranslate();

  return (
    <Stack align="center">
      <DotLottieReact
        src="/lottie_loading.json"
        loop
        autoplay
        style={{ width: 320, height: 320 }}
      />
      <H7>{t('Onboarding.ProcessingApplicationDescription')}</H7>
    </Stack>
  );
};
